/**
 * vuetify config optimizada para Vuetify 2.7.2
 */

import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify, {
  VCard, VCardTitle, VCardText, VCardActions, VIcon, VRow, VCol,
  VDatePicker, VContainer, VDivider, VTextField, VSpacer, VAvatar,
  VSlideGroup, VTooltip, VDialog, VList, VListItem, VListItemTitle,
  VListItemText, VSheet, VMenu
} from 'vuetify/lib'

import i18n from '@/locale/index'
import locales from '@/locale/vuetify'
import themes from './vuetifyThemes'
import es from 'vuetify/lib/locale/es'

// import { MIN_DATE } from '@/utils/minDatesFilters'
// import { nowDay } from '@/utils/moment'

/**
 * AQUI VAN LOS DEFAULTS CORRECTAMENTE APLICADOS
 * (ANTES de Vue.use(Vuetify))
 */
// VMenu.options.props.offsetY.default = true
// VMenu.options.props.minWidth.default = 'auto'

VDatePicker.options.props.noTitle.default = true
// VDatePicker.options.props.min.default = MIN_DATE
// VDatePicker.options.props.max.default = nowDay()
VDatePicker.options.props.locale.default = 'es-mx'

Vue.use(Vuetify, {
  components: {
    VDatePicker,
    VCard,
    VSheet,
    VCardTitle,
    VCardText,
    VCardActions,
    VIcon,
    VRow,
    VCol,
    VTextField,
    VContainer,
    VDivider,
    VSlideGroup,
    VDialog,
    VList,
    VListItem,
    VListItemTitle,
    VListItemText,
    VAvatar,
    VSpacer,
    VTooltip,
    VMenu
  }
})

/**
 * Configuración del tema/control de modo oscuro
 */
const PRODUCTION_MODE = process.env.NODE_ENV !== 'production'
const theme = PRODUCTION_MODE ? themes[0] : themes[1]

const preset = {
  theme: {
    dark: false,
    themes: theme
  },
  icons: { iconfont: 'mdi' },
  lang: {
    locales,
    current: es,
    t: (k, ...p) => i18n.t(k, p)
  }
}

const vuetify = new Vuetify({ ...preset,
  defaults: {
    VDatePicker: { noTitle: true }
  } })

/**
 * Cambiar tema dinámicamente
 */
export async function setVuetifyTheme(index) {
  if (vuetify.framework.theme.themes !== themes[index]) {
    vuetify.framework.theme.themes.light = themes[index].light || themes[0].light
    vuetify.framework.theme.themes.dark = themes[index].dark || themes[0].dark
  }
}

/**
 * Activar/desactivar modo oscuro
 */
export async function setVuetifyThemeDark(dark) {
  vuetify.framework.theme.dark = dark
}

/**
 * Adaptarse al modo oscuro del sistema operativo
 */
const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
darkModeMediaQuery.addEventListener('change', (e) => {
  const darkModeOn = e.matches
  setVuetifyThemeDark(darkModeOn)
})

export default vuetify
